
// 指定された文字列から、指定された文字列配列の中身をすべて削除する関数
export const removeStrings = (str: string, removeStrs: string[]): string => {
    let result = str;
    removeStrs.forEach(removeStr => {
      result = result.split(removeStr).join('');
    });
    return result;
};
